<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" [hideLegend]="true"></eaglei-leaflet-layer-header>

<ng-container *ngIf="isActive">
    <mat-form-field appearance="outline" class="wide">
        <mat-label>Data Year</mat-label>
        <mat-select placeholder="Data Year" [formControl]="yearControl">
            <mat-option [value]="-1">View All</mat-option>
            @for (year of years(); track id) {
            <mat-option [value]="year">{{ year }}</mat-option>

            }
        </mat-select>
    </mat-form-field>

    <div #legendElement>
        <div class="dot-legend">
            <div class="circle"></div>
            <p>Survey Location</p>
        </div>
    </div>
</ng-container>
